export const googlePlaceDetail = (fields: Array<string>, placeId?: string) =>
  ['placeDetails', placeId, fields] as const

export const googleExplorePlacesDetails = (placeIds: string) =>
  ['explorePlacesDetails', placeIds] as const
